import { useThree } from '@react-three/fiber'
import { usePointCloudContext } from 'features/pointClouds'
import { useEffect, useRef } from 'react'
import * as THREE from 'three'

export const FloorPlane = () => {
  const { showTiles, pointCloudMinY, isLoadingPotreePointClouds } =
    usePointCloudContext()
  const { scene } = useThree()
  const floorPlaneRef = useRef<THREE.Mesh>(
    new THREE.Mesh(
      new THREE.PlaneGeometry(10000, 10000),
      new THREE.MeshBasicMaterial({ visible: false })
    )
  )
  const gridRef = useRef(new THREE.GridHelper(10000, 1000))

  useEffect(() => {
    const plane = floorPlaneRef.current
    const grid = gridRef.current
    plane.rotation.x = -Math.PI / 2

    if (!showTiles) {
      scene.add(plane)
      scene.add(grid)
    } else {
      scene.remove(plane)
      scene.remove(grid)
    }

    return () => {
      scene.remove(plane)
      scene.remove(grid)
    }
  }, [showTiles, scene])

  useEffect(() => {
    if (showTiles || isLoadingPotreePointClouds) return

    if (pointCloudMinY !== undefined) {
      floorPlaneRef.current.position.set(0, pointCloudMinY, 0)
      gridRef.current.position.set(0, pointCloudMinY, 0)
    } else {
      floorPlaneRef.current.position.set(0, -200, 0)
      gridRef.current.position.set(0, -200, 0)
    }
  }, [pointCloudMinY, isLoadingPotreePointClouds, showTiles])

  return null
}
